<script setup lang="ts">
import { formatDate, formatTime } from '../format';
import { usePdsOrdersStore } from '../stores/orders.store';

const store = usePdsOrdersStore();
</script>

<template>
  <div
    class="bg-accent text-accent-encre flex size-10 shrink-0 items-center justify-center rounded-[20px] text-[14px] leading-[1.4] font-semibold"
  >
    N
  </div>
  <div class="flex flex-col gap-[2px] whitespace-nowrap">
    <p class="text-[18px] leading-[1.2] font-bold">
      {{ formatTime(store.now) }}
    </p>
    <p class="text-encre-douce text-[12px] leading-[1.45] max-sm:hidden">
      {{ formatDate(store.now) }}
    </p>
  </div>
</template>
